import React, { useCallback } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { DropDiv, Icon } from './styles';
import { SETTING_TEAMS_MENU_OPTION } from '../../../global/constants';
import Dropdown from '../../Dropdown/MainDropdown';
import DropdownItem from '../../Dropdown/DropdownItem';
import { MobxFilteredTasksListInterface } from '../../../interfaces/TaskInterface';

interface Props {
  groupDetail?: MobxFilteredTasksListInterface;
  loadData: () => void;
  isTaskPage?: boolean;
  isWidth?: boolean;
  workspaceDetail?: any; //Remove any
  collapseIds?: string[];
  setCollapse?: (value: string) => void;
}

const CollapseDropdown: React.FC<Props> = (props) => {
  const { groupDetail, collapseIds, setCollapse } = props;

  const collapse = useCallback(
    async (group: MobxFilteredTasksListInterface) => {
      if (setCollapse) setCollapse(String(group.id));
    },
    [setCollapse]
  );

  const handleClick = useCallback(
    (key: number | string) => {
      key = Number(key);
      if (key === SETTING_TEAMS_MENU_OPTION.ADMIN) {
        if (groupDetail) {
          collapse(groupDetail);
        }
      }
    },
    [collapse, groupDetail]
  );

  return (
    <>
      <DropDiv>
        <Dropdown
          modalTitle='Manage Group'
          activeClassName='active-state'
          content={
            <Icon>
              <SVGIcon name='three-dots-horizontal-icon' width='16' height='16' viewBox='0 0 18 18' />
            </Icon>
          }
          trigger='click'>
          <DropdownItem
            key={SETTING_TEAMS_MENU_OPTION.ADMIN}
            label={collapseIds?.includes(String(groupDetail?.id)) ? 'Expand Group' : 'Collapse Group'}
            onClick={() => handleClick(SETTING_TEAMS_MENU_OPTION.ADMIN)}
          />
        </Dropdown>
      </DropDiv>
    </>
  );
};

export default CollapseDropdown;
